<template>
  <main class="w-full flex-grow p-6">
    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">News</div>
            <div @click="showModalSeo" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="">
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Title
              <div class="ml-8 font-normal">{{ seo.title }}</div>
            </div>
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Description
              <div class="ml-8 font-normal">{{ seo.meta_description }}</div>
            </div>
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Google Site
              <div class="ml-8 font-normal">
                {{ seo.meta_google_site_verification }}
              </div>
            </div>
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Keywords
              <div class="ml-8 font-normal">{{ seo.meta_keywords }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal news -->
    <div
      v-if="modalSeo"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalSeo"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Edit News Description
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Title</label>
                <textarea
                  v-model="update.title"
                  rows="2"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200  mb-4"
                  placeholder="Promo Title"
                ></textarea>
              </div>
            </div>
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <textarea
                  v-model="update.meta_description"
                  rows="2"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                  placeholder="Promo Description"
                ></textarea>
                <div
                  class="text-right text-sm mb-4"
                  :class="[
                    update?.meta_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.meta_description?.length }} used out of 2000
                  characters
                </div>
              </div>
            </div>
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Google Site</label
                >
                <textarea
                  v-model="update.meta_google_site_verification"
                  rows="2"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200  mb-4"
                  placeholder="Promo Google Site"
                ></textarea>
              </div>
            </div>
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >keywords</label
                >
                <textarea
                  v-model="update.meta_keywords"
                  rows="2"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200  mb-4"
                  placeholder="Promo keywords"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalSeo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateSeo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalSeo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <SuccessNotif />
    <Warning />
  </main>
</template>

<script>
import API from "../../api";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Information",
  components: {
    Warning,
    SuccessNotif,
  },
  data() {
    return {
      modalSeo: false,
      isOpen: false,
      update: {
        meta_description: "",
        meta_google_site_verification: "",
        meta_keywords: "",
        title: "",
      },
      seo: {},
      description: "",
      saveButton: "Save",
    };
  },
  methods: {
    showModalSeo: function() {
      this.update = {
        meta_description: this.seo.meta_description,
        meta_google_site_verification: this.seo.meta_google_site_verification,
        meta_keywords: this.seo.meta_keywords,
        title: this.seo.title,
      };
      this.description = "";
      this.modalSeo = !this.modalSeo;
    },
    updateSeo: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/seo`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.seo.id,
            meta_description: this.update.meta_description,
            meta_google_site_verification: this.update
              .meta_google_site_verification,
            meta_keywords: this.update.meta_keywords,
            title: this.update.title,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.modalSeo = false;
        this.findSeo();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalSeo = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    findSeo: async function() {
      try {
        let res = await fetch(`${API}v1/seo`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.seo = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findSeo();
  },
};
</script>
